import { useState } from 'react';
import { Dialog, Button, toaster, SelectMenu, Paragraph } from 'evergreen-ui';
import sectionServices from '../services/sectionServices';

const RemoveSectionFormDialog = ({ isShown, sections, onSectionRemoved, onClose }) => {
    const [selectedSection, setSelectedSection] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleRemove = async () => {
        if (!selectedSection) {
            toaster.warning('Seleziona una sezione da rimuovere.');
            return;
        }

        try {
            setIsSubmitting(true);
            await sectionServices.removeSection(selectedSection);
            toaster.success('Sezione rimossa con successo!');
            onSectionRemoved(selectedSection);
            onClose();
        } catch (error) {
            console.error('Errore durante la rimozione della sezione:', error);
            toaster.danger('Errore durante la rimozione della sezione.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetState = () => {
        setSelectedSection(null);
    };

    return (
        <Dialog
            isShown={isShown}
            title="Rimuovi cartella"
            onCloseComplete={() => {
                resetState();
                onClose();
            }}
            confirmLabel="Rimuovi"
            cancelLabel='Annulla'
            onConfirm={handleRemove}
            isConfirmLoading={isSubmitting}
        >
            <Paragraph color="danger" marginBottom={16}>
                Attenzione: Tutti i file all'interno della cartella selezionata non saranno più reperibili. Verranno anche eliminate tutte le sottocartelle collegate.
            </Paragraph>
            <SelectMenu
                title="Seleziona cartella"
                options={sections.map((section) => ({ label: section.name, value: section.id }))}
                selected={selectedSection}
                onSelect={(item) => setSelectedSection(item.value)}
            >
                <Button>{
                    selectedSection
                        ? sections.find((section) => section.id === selectedSection)?.name
                        : 'Seleziona cartella da rimuovere'
                }</Button>
            </SelectMenu>
        </Dialog>
    );
};

export default RemoveSectionFormDialog;